import { render } from "./DialogCancelCompleted.vue?vue&type=template&id=6866b4b6"
import script from "./DialogCancelCompleted.vue?vue&type=script&lang=js"
export * from "./DialogCancelCompleted.vue?vue&type=script&lang=js"
script.render = render

export default script